import React from 'react';

import { FormattedMessage } from 'react-intl';

import { ErrorState } from 'src/components/generic-message';

import messages from './error-state.i18n';

type FileErrorProps = {
  onClick?: () => void;
};

export default class FileError extends React.PureComponent<FileErrorProps> {
  render() {
    return (
      <ErrorState
        header={<FormattedMessage {...messages.errorHeaderFile} />}
        description={
          <FormattedMessage tagName="p" {...messages.errorDescriptionFile} />
        }
        onClick={this.props.onClick}
      />
    );
  }
}
